export enum UserActivityType {
	SurveyCompleted = 1,
	// Feedback= 2, // obsolete value, can be removed
	Withdrawal = 3,
	CodeScan = 4,
	RepeatCodeScan = 5,
}